import React from "react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import {
    Clock, HeartPulse, ChefHat, Sprout, Salad,
    Crown, CalendarHeart, Repeat,
} from "lucide-react";

const ICONS = [Clock, HeartPulse, ChefHat, Sprout, Salad, Crown, CalendarHeart, Repeat];

export const Benefits = () => {
    const { t } = useTranslation();
    const titles = t("benefits.items", { returnObjects: true }) || [];

    return (
        <section
            id="beneficios"
            data-testid="benefits-section"
            className="py-24 md:py-32"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 mb-14 md:mb-20">
                    <div className="lg:col-span-5">
                        <div className="flex items-center gap-3 mb-5">
                            <span className="gold-divider" />
                            <span className="text-xs uppercase tracking-[0.24em] text-stone-500">
                                {t("benefits.eyebrow")}
                            </span>
                        </div>
                        <h2 className="font-serif text-4xl sm:text-5xl text-stone-900 tracking-tight leading-[1.05]">
                            {t("benefits.title_1")}{" "}
                            <em className="italic text-gold-deep font-normal">
                                {t("benefits.title_em")}
                            </em>
                            .
                        </h2>
                    </div>
                    <div className="lg:col-span-6 lg:col-start-7 flex items-end">
                        <p className="text-lg text-stone-600 font-light leading-relaxed">
                            {t("benefits.subtitle")}
                        </p>
                    </div>
                </div>

                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5">
                    {titles.map((title, i) => {
                        const Icon = ICONS[i] || Clock;
                        return (
                            <motion.div
                                key={`benefit-${i}-${title}`}
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, margin: "-60px" }}
                                transition={{ duration: 0.6, delay: i * 0.05, ease: [0.16, 1, 0.3, 1] }}
                                data-testid={`benefit-${i}`}
                                className="group p-7 md:p-8 bg-white rounded-2xl ring-1 ring-stone-200 hover:ring-gold-soft hover:-translate-y-1 transition-all duration-500"
                            >
                                <Icon
                                    size={28}
                                    strokeWidth={1.3}
                                    className="text-gold-deep mb-6 group-hover:text-gold transition-colors"
                                />
                                <h3 className="font-serif text-xl md:text-2xl text-stone-900 leading-tight">
                                    {title}
                                </h3>
                            </motion.div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};
